import { CountryCode } from '@dayetopia/library/types';

type RedirectRule = {
  uid: string;
  country?: CountryCode[];
  notCountry?: CountryCode[];
  url: string;
};

const redirectRules: RedirectRule[] = [
  {
    uid: 'tampons',
    country: [CountryCode.US, CountryCode.BG],
    url: '/products/organic-nude-tampons/'
  },
  {
    uid: 'at-home-vaginal-screening',
    country: [CountryCode.US],
    url: '/products/vaginal-testing/'
  },
  {
    uid: 'vaginal-testing',
    notCountry: [CountryCode.US],
    url: '/products/at-home-vaginal-screening/'
  },
  {
    uid: 'organic-cbd-tampons',
    notCountry: [CountryCode.US, CountryCode.BG],
    url: '/products/tampons/'
  },
  {
    uid: 'organic-pads',
    notCountry: [CountryCode.US],
    url: '/products/organic-hemp-pads/'
  },
  {
    uid: 'organic-tampons-trial-box',
    notCountry: [CountryCode.US],
    url: '/products/tampons/'
  },
  {
    uid: 'organic-cbd-nude-tampons',
    notCountry: [CountryCode.US, CountryCode.BG],
    url: '/products/tampons/'
  },
  {
    uid: 'organic-nude-tampons',
    notCountry: [CountryCode.US, CountryCode.BG],
    url: '/products/tampons/'
  },
  {
    uid: 'organic-cbd-nude-tampons',
    notCountry: [CountryCode.US, CountryCode.BG],
    url: '/products/organic-tampons/'
  },
  {
    uid: 'organic-tampons',
    country: [CountryCode.US, CountryCode.BG],
    url: '/products/organic-cbd-nude-tampons/'
  },
  {
    uid: 'period-care-bundle',
    notCountry: [CountryCode.US],
    url: '/products/bundles/'
  },
  {
    uid: 'nurse-consultation',
    notCountry: [CountryCode.US, CountryCode.GB],
    url: '/'
  },
  {
    uid: 'free-consultations',
    notCountry: [CountryCode.GB],
    url: '/'
  },
  {
    uid: 'cbd-bundle',
    country: [CountryCode.PT],
    url: '/products'
  },
  {
    uid: 'organic-heavy-flow-bundle',
    country: [CountryCode.PT, CountryCode.US],
    url: '/products'
  },
  {
    uid: 'organic-reg-flow-bundle',
    country: [CountryCode.PT, CountryCode.US],
    url: '/products'
  },
  {
    uid: 'bamboo-menstrual-pads',
    url: '/products/organic-hemp-pads/'
  }
];

const handlePageRedirect = (uid: string, country: CountryCode, navigate: Function) => {
  const matchiingRule = redirectRules.find(
    (rule) =>
      rule.uid === uid &&
      ((rule.country && rule.country.includes(country)) ||
        (rule.notCountry && !rule.notCountry.includes(country)) ||
        (!rule.country && !rule.notCountry))
  );

  if (matchiingRule) {
    navigate(matchiingRule.url, { replace: true });
  }
};

export default handlePageRedirect;
